import React from "react";

export default function LoadingCards() {
    return (
        <div className="grid grid-cols-2 gap-3 fade-bottom opacity-50">
            {[...Array(2)].map((_, i) => (
                <div
                    key={i}
                    className="border rounded-lg border-grey-02 min-h-75 animate-pulse bg-linear-to-b from-dark-01 to-dark-03"
                />
            ))}
        </div>
    )
}